import { render } from "./ThePayment.vue?vue&type=template&id=7ce98303"
const script = {}
script.render = render

export default script